import * as tslib_1 from "tslib";
import { EventBase } from "@awayjs/core";
/**
 * Dispatched to notify changes in a sub geometry object's state.
 *
 * @class away.events.ElementsEvent
 * @see away.core.base.Graphics
 */
var ElementsEvent = (function (_super) {
    tslib_1.__extends(ElementsEvent, _super);
    /**
     * Create a new GraphicsEvent
     * @param type The event type.
     * @param attributesView An optional data type of the vertex data being updated.
     */
    function ElementsEvent(type, attributesView) {
        var _this = _super.call(this, type) || this;
        _this._attributesView = attributesView;
        return _this;
    }
    Object.defineProperty(ElementsEvent.prototype, "attributesView", {
        /**
         * The attributes view of the vertex data.
         */
        get: function () {
            return this._attributesView;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Clones the event.
     *
     * @return An exact duplicate of the current object.
     */
    ElementsEvent.prototype.clone = function () {
        return new ElementsEvent(this.type, this._attributesView);
    };
    return ElementsEvent;
}(EventBase));
export { ElementsEvent };
/**
 * Dispatched when a Elements's index data has been updated.
 */
ElementsEvent.INVALIDATE_INDICES = "invalidateIndices";
/**
 * Dispatched when a Elements's index data has been disposed.
 */
ElementsEvent.CLEAR_INDICES = "clearIndices";
/**
 * Dispatched when a Elements's vertex data has been updated.
 */
ElementsEvent.INVALIDATE_VERTICES = "invalidateVertices";
/**
 * Dispatched when a Elements's vertex data has been disposed.
 */
ElementsEvent.CLEAR_VERTICES = "clearVertices";



// WEBPACK FOOTER //
// ../dist/lib/events/ElementsEvent.js